import { mergeTemplate } from './base-template';

export const coiffeurTemplate = mergeTemplate({
  name: 'Coiffeur',
  icon: '💇',
  settings: {
    primaryColor: '#1a5d53',
    accentColor: '#ec4899',
    fontStack: 'dmsans',
    pageAngebot: {
      heroTitle: 'Unsere Services & Preise',
      heroSubtitle: 'Für jeden Wunsch die richtige Behandlung',
      packages: [
        { name: 'Schnitt & Styling', price: 'ab CHF 65', description: 'Schnitt, Waschen, Föhnen und Styling', features: 'Beratung, Haarwäsche, Präzisionsschnitt, Styling, Pflegetipps', highlighted: false },
        { name: 'Farbe & Strähnchen', price: 'ab CHF 120', description: 'Professionelle Colorationen und Highlights', features: 'Farbberatung, Coloration/Strähnchen, Pflege, Glossing', highlighted: true },
        { name: 'Spezialbehandlungen', price: 'ab CHF 90', description: 'Hochwertige Haar- und Kopfhautbehandlungen', features: 'Keratin-Treatment, Kopfhautanalyse, Intensivpflege, Haarverlängerung', highlighted: false },
      ],
      ctaTitle: 'Bereit für Ihren neuen Look?',
      ctaText: 'Buchen Sie Ihren Termin online oder rufen Sie uns an.',
      ctaButtonText: 'Termin buchen',
    },
    pageMethoden: {
      heroTitle: 'Unsere Philosophie',
      heroSubtitle: 'Handwerk, Beratung und Wohlfühlen',
      introText: 'Ein Besuch bei uns ist mehr als ein Haarschnitt. Wir nehmen uns Zeit für Beratung, setzen auf Qualitätsprodukte und sorgen für Ihr Wohlbefinden.',
      steps: [
        { title: 'Beratung', description: 'Persönliches Gespräch über Ihre Wünsche, Ihren Stil und Ihren Alltag' },
        { title: 'Behandlung', description: 'Fachkundige Ausführung mit Premiumprodukt und Liebe zum Detail' },
        { title: 'Styling', description: 'Perfektes Finish und Tipps für die Pflege zu Hause' },
        { title: 'Nachbetreuung', description: 'Pflegeempfehlungen und Nachsorgetermine bei Bedarf' },
      ],
      tools: [
        { name: 'Premium-Produkte', description: 'Ausgewählte Profimarken für beste Ergebnisse' },
        { name: 'Farbdiagnostik', description: 'Digitale Farbberatung für perfekte Töne' },
        { name: 'Online-Buchung', description: '24/7 Terminbuchung über unser System' },
      ],
      philosophyTitle: 'Unser Versprechen',
      philosophyText: 'Jeder Mensch verdient einen grossartigen Haarschnitt. Wir hören zu, beraten ehrlich und liefern Ergebnisse, die begeistern.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Salon',
      heroSubtitle: 'Kreativität trifft Handwerk',
      introText: 'Unser Team aus passionierten Coiffeuren und Coiffeusen steht für Kreativität, Qualität und persönliche Betreuung.',
      timeline: [
        { year: '2012', text: 'Eröffnung des Salons' },
        { year: '2018', text: 'Erweiterung und Modernisierung' },
        { year: '2023', text: 'Einführung nachhaltiger Produktlinien' },
      ],
      values: [
        { title: 'Kreativität', description: 'Trends kennen, Individualität betonen' },
        { title: 'Handwerk', description: 'Solide Ausbildung und kontinuierliche Weiterbildung' },
        { title: 'Wohlfühlen', description: 'Eine Atmosphäre, in der Sie sich entspannen können' },
      ],
      certifications: 'Eidg. Fachausweis Coiffeur/Coiffeuse, L\'Oréal Certified',
    },
  },
  components: {
    header: {
      companyName: 'Studio Muster',
      logoText: 'SM',
      navItems: ['Preise', 'Philosophie', 'Salon', 'Kontakt'],
      ctaText: 'Termin buchen',
    },
    hero: {
      title: 'Hair & Style – mit Gefühl',
      subtitle: 'Schnitt, Farbe, Styling – in entspannter Atmosphäre.',
      primaryBtn: 'Termin buchen',
      secondaryBtn: 'Services',
    },
    trust: {
      items: [
        { value: 'Beratung', label: 'Look' },
        { value: 'Qualität', label: 'Produkte' },
        { value: 'Style', label: 'Trends' },
        { value: 'Relax', label: 'Atmosphäre' },
      ],
    },
    services: {
      title: 'Services',
      subtitle: '',
      items: [
        { icon: '✂️', title: 'Schnitt', text: 'Passend zu Ihrem Typ.' },
        {
          icon: '🎨',
          title: 'Farbe',
          text: 'Von natürlich bis bold – sauber umgesetzt.',
        },
        {
          icon: '💫',
          title: 'Styling',
          text: 'Für Alltag und Anlass.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Kreativität und Erfahrung.',
      members: [
        {
          name: 'Lisa Muster',
          role: 'Inhaberin & Coiffeuse',
          image: '',
          bio: 'Eidg. Fachausweis, über 15 Jahre Erfahrung. Spezialisiert auf Farbe und Styling.',
        },
        {
          name: 'Kevin Schmid',
          role: 'Coiffeur & Colorist',
          image: '',
          bio: 'Ausbildung in Zürich und Paris. Experte für Balayage und kreative Colorationen.',
        },
      ],
    },
    testimonials: {
      title: 'Stimmen',
      items: [
        {
          quote: 'Super Beratung und top Ergebnis.',
          author: 'Kundin',
          role: '',
        },
        {
          quote: 'Endlich ein Salon, der genau versteht, was ich will. Bin seit drei Jahren Stammkundin.',
          author: 'Martina L.',
          role: 'Stammkundin',
        },
        {
          quote: 'Die Farbberatung war hervorragend. Das Ergebnis sieht natürlich und edel aus.',
          author: 'Sandra K.',
          role: 'Coloration-Kundin',
        },
        {
          quote: 'Entspannte Atmosphäre, toller Kaffee und ein perfekter Schnitt. Was will man mehr?',
          author: 'Michael R.',
          role: 'Stammkunde',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Kann ich online buchen?',
          answer:
            'Online-Buchung kann ergänzt werden – alternativ telefonisch.',
        },
        {
          question: 'Was kostet ein Herrenschnitt?',
          answer: 'Ein Herrenschnitt inklusive Waschen und Styling kostet ab CHF 45. Der genaue Preis hängt vom gewünschten Aufwand ab.',
        },
        {
          question: 'Bieten Sie auch Hochzeits-Styling an?',
          answer: 'Ja, wir bieten Braut- und Hochzeits-Styling inklusive Probe-Styling an. Kontaktieren Sie uns frühzeitig für eine individuelle Beratung.',
        },
      ],
    },
    cta: {
      title: 'Termin buchen',
      subtitle: 'Wir freuen uns auf Sie.',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
    footer: {
      companyName: 'Studio Muster',
      tagline: 'Coiffeur in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
  },
});
